import React, { useState, useEffect } from "react";
import Autocomplete from "./Autocomplete.jsx";
import { t } from "../i18n";
import "./Friends.css";

const FriendForm = ({ userid, loadFriends }) => {
 const [friendname, setFriendname] = useState("");
 const [friendid, setFriendid] = useState("");
 const [responseMessage, setResponseMessage] = useState("");
 const [users, setUsers] = useState([]);
 const [submitting, setSubmitting] = useState(false); 

 useEffect(() => {
   fetch(process.env.REACT_APP_API_PATH + "/users/", {
    method: "GET",
     headers: {
       "Content-Type": "application/json",
       Authorization: "Bearer " + sessionStorage.getItem("token"),
     },
   })
     .then((res) => res.json())
     .then((result) => {
       const filtered = result[0].filter((u) => u.attributes?.username);
       setUsers(filtered);
     });
 }, []); // ✅ No props used inside, so empty array is fine

 const selectAutocomplete = (id) => {
  const selectedUser = users.find((u) => u.id === parseInt(id));
  setFriendid(id);
  setFriendname(selectedUser?.attributes?.username || "Unknown");
};

 const submitHandler = async (event) => {
   event.preventDefault();
   if (submitting) return;
   setSubmitting(true);
   setResponseMessage("");
    const userId = parseInt(sessionStorage.getItem("user"));
    // Check if the friend already exists and is in a valid status (not rejected or canceled)
   const checkRes = await fetch(
     `${process.env.REACT_APP_API_PATH}/connections?anyUserID=${userId}`,
     {
       headers: {
         Authorization: "Bearer " + sessionStorage.getItem("token"),
       },
     }
   );
   const connections = await checkRes.json();
    const hasExistingConnection = connections[0]?.some((conn) => {
     const pairMatch =
       (conn.fromUser.id === userId && conn.toUser.id === friendid) ||
       (conn.toUser.id === userId && conn.fromUser.id === friendid);
     const validStatuses = ["pending", "active", "blocked"];
     return pairMatch && validStatuses.includes(conn.attributes.status);
   });
    if (hasExistingConnection) {
     setResponseMessage(t("connection_already_exists"));
     setSubmitting(false);
     return;
   }
    // Send the request
   fetch(process.env.REACT_APP_API_PATH + "/connections", {
     method: "POST",
     headers: {
       "Content-Type": "application/json",
       Authorization: "Bearer " + sessionStorage.getItem("token"),
     },
     body: JSON.stringify({
       toUserID: friendid,
       fromUserID: userId,
       attributes: { type: "friend", status: "pending" },
     }),
   })
     .then((res) => res.json())
     .then(() => {
       setResponseMessage(`Connection request sent to ${friendname}`); // Display friend's name
       loadFriends();  // Re-fetch the connections
       setSubmitting(false);
     })
     .catch(() => {
       setResponseMessage(t("error_sending_request"));
       setSubmitting(false);
     });
 }; 
  return (
    <form onSubmit={submitHandler} className="profileform">
   <div className="autocomplete-wrapper">
  <div className="autocomplete">
    <Autocomplete
      suggestions={users}
      selectAutocomplete={selectAutocomplete}
    />
  </div>
  {responseMessage && (
    <div className="connect-msg">{responseMessage}</div>
  )}
  <input
    type="submit"
    value={t("connect")}
    disabled={submitting}
    className="connect-btn"
  />
</div>
  </form>
 );
};

export default FriendForm;